export default __webpack_public_path__ + "media/images/brands/xpress/services/service-08-2954b63a7439d7ab78a74e686a5c5901.jpg";